// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2578":"00f3b5bf","5353":"155867b3"}[chunkId] + ".chunk.css";
};